// extracted by mini-css-extract-plugin
export default {"PageMenu":"PageMenu2d6Rb_TWMndW"};